import React from "react";
import { debounce } from "../../../util/debounce";
const useFullDimensions = (delay = 300) => {
    const [height, setHeight] = React.useState(window === null || window === void 0 ? void 0 : window.innerHeight);
    const [width, setWidth] = React.useState(window === null || window === void 0 ? void 0 : window.innerWidth);
    React.useEffect(() => {
        setHeight(window.innerHeight);
        setWidth(window.innerWidth);
        const listener = window.addEventListener("resize", debounce(() => {
            setHeight(window.innerHeight);
            setWidth(window.innerWidth);
        }, delay));
        // @ts-expect-error - TS2769 - No overload matches this call.
        return () => window.removeEventListener("resize", listener);
    }, [delay]);
    return React.useMemo(() => ({ width, height }), [height, width]);
};
export default useFullDimensions;
